import { storePageViewData } from './storePageViewData'
import { storeCartState } from './storeCartState'
import { pushCartView } from './pushCartView'
import { pushPageView } from './pushPageView'
import { pushPageType } from './pushPageType'
import { storeUserState } from './storeUserState'
import { pushAddToCart, pushRemoveFromCart } from './pushCartItemUpdate'
import { pushCheckoutOption } from './pushCheckoutOption'
import { pushCheckoutStep } from './pushCheckoutStep'
import { pushOrder } from './pushOrder'
import { pushPdp } from './pushPdp'
import { pushPlp } from './pushPlp'
import { pushProductClick } from './pushProductClick'
import { pushPromotionClick } from './pushPromotionClick'
import { pushPromotionView } from './pushPromotionView'
import { pushSearch } from './pushSearch'
import { pushBannerClickView } from './pushBannerClickView'
import { pushMenuClick } from './pushMenuClick'
import { pushApplyCoupon } from './pushApplyCoupon'

export const GTMEvents = {
    CART_VIEW: pushCartView,
    CART_STATE: storeCartState,
    PAGE_VIEW: storePageViewData,
    PAGE_VIEW_DATA: storePageViewData,
    PUSH_PAGE_VIEW: pushPageView,
    PUSH_PAGE_TYPE: pushPageType,
    USER_STATE: storeUserState,
    ADD_TO_CART: pushAddToCart,
    REMOVE_FROM_CART: pushRemoveFromCart,
    CHECKOUT_OPTION: pushCheckoutOption,
    CHECKOUT: pushCheckoutStep,
    PLACE_ORDER: pushOrder,
    PDP: pushPdp,
    PLP: pushPlp,
    PRODUCT_CLICK: pushProductClick,
    PROMOTION_CLICK: pushPromotionClick,
    PROMOTION_VIEW: pushPromotionView,
    SEARCH: pushSearch,
    BANNER_CLICK: pushBannerClickView,
    MENU_CLICK: pushMenuClick,
    APPLY_COUPON: pushApplyCoupon
}
